export const CONTACT_EMAIL = "contact@lezo.dev";
export const CONTACT_URL = `mailto:${CONTACT_EMAIL}`;
export const BOOKING_URL = "https://cal.com/simon-boisset/contact-lezo";
export const GITHUB_URL = "https://github.com/lezo-dev";
// TODO: confirm both URLs before publication.
export const QUESTOVERY_URL = "https://questovery.com";
export const VAERDICT_URL = "https://vaerdict.fr";
export const CHOUIC_URL = "https://chouic.com";
export const FOUNDER_URL = "https://simonboisset.com";
